"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.musicVolumeChannelID = exports.sfxVolumeChannelID = void 0;
const pixel_pigeon_1 = require("pixel-pigeon");
exports.sfxVolumeChannelID = (0, pixel_pigeon_1.createVolumeChannel)({
    name: "SFX",
});
exports.musicVolumeChannelID = (0, pixel_pigeon_1.createVolumeChannel)({
    name: "Music",
});
